//It will be refactored with the clening CSS ticket

const styles = theme => ({
  modalRoot: {
    width: 560
  },
  formTitle: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 'bold',
    letterSpacing: '0.25px',
    lineHeight: '24px',
    margin: 0,
    marginBottom: theme.spacing.unit * 1.875
  },
  formSubTitle: {
    color: 'rgba(12,31,44,0.6)',
    fontFamily: 'Roboto',
    fontSize: '16px',
    lineHeight: '24px',
    margin: 0
  },
  modalFooter: {
    marginTop: theme.spacing.unit * 4
  }
});

export default styles;
